/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ProjektBilag } from '../models/projekt-bilag';
import { FileStreamResult } from '../models/file-stream-result';
@Injectable({
  providedIn: 'root',
})
class ProjekterBilagService extends __BaseService {
static readonly getProjektBilagListPath = '/projekter/{projektId}/bilag';
static readonly addProjektBilagPath = '/projekter/{projektId}/bilag';
static readonly downloadPath = '/projekter/{projektId}/bilag/download';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Henter projekt bilag.
   * @param projektId undefined
   * @return Success
   */
  private getProjektBilagListResponse(projektId: string): __Observable<__StrictHttpResponse<Array<ProjektBilag>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/projekter/${encodeURIComponent(String(projektId))}/bilag`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ProjektBilag>>;
      })
    );
  }

  /**
   * Henter projekt bilag.
   * @param projektId undefined
   * @return Success
   */
  getProjektBilagList(projektId: string): __Observable<Array<ProjektBilag>> {
    return this.getProjektBilagListResponse(projektId).pipe(
      __map(_r => _r.body as Array<ProjektBilag>)
    );
  }

  /**
   * Tilføjer bilag til projektet.
   * @param params The `ProjekterBilagService.AddProjektBilagParams` containing the following parameters:
   *
   * - `projektId`: Projektets ID.
   *
   * - `projektVersion`: Projektets VersionsNr.
   *
   * - `fileInput`:
   *
   * @return Success
   */
  private addProjektBilagResponse(params: ProjekterBilagService.AddProjektBilagParams): __Observable<__StrictHttpResponse<Array<ProjektBilag>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;

    if (params.projektVersion != null) __params = __params.set('projektVersion', params.projektVersion.toString());
    if (params.fileInput != null) { __formData.append('fileInput', params.fileInput as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/${encodeURIComponent(String(params.projektId))}/bilag`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ProjektBilag>>;
      })
    );
  }

  /**
   * Tilføjer bilag til projektet.
   * @param params The `ProjekterBilagService.AddProjektBilagParams` containing the following parameters:
   *
   * - `projektId`: Projektets ID.
   *
   * - `projektVersion`: Projektets VersionsNr.
   *
   * - `fileInput`:
   *
   * @return Success
   */
  addProjektBilag(params: ProjekterBilagService.AddProjektBilagParams): __Observable<Array<ProjektBilag>> {
    return this.addProjektBilagResponse(params).pipe(
      __map(_r => _r.body as Array<ProjektBilag>)
    );
  }

  /**
   * Download bilag.
   * @param params The `ProjekterBilagService.DownloadParams` containing the following parameters:
   *
   * - `projektId`:
   *
   * - `projektVersion`:
   *
   * - `bilagId`:
   *
   * @return Success
   */
  private downloadResponse(params: ProjekterBilagService.DownloadParams): __Observable<__StrictHttpResponse<FileStreamResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.projektVersion != null) __params = __params.set('projektVersion', params.projektVersion.toString());
    if (params.bilagId != null) __params = __params.set('bilagId', params.bilagId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/projekter/${encodeURIComponent(String(params.projektId))}/bilag/download`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FileStreamResult>;
      })
    );
  }

  /**
   * Download bilag.
   * @param params The `ProjekterBilagService.DownloadParams` containing the following parameters:
   *
   * - `projektId`:
   *
   * - `projektVersion`:
   *
   * - `bilagId`:
   *
   * @return Success
   */
  download(params: ProjekterBilagService.DownloadParams): __Observable<FileStreamResult> {
    return this.downloadResponse(params).pipe(
      __map(_r => _r.body as FileStreamResult)
    );
  }
}

module ProjekterBilagService {

  /**
   * Parameters for addProjektBilag
   */
  export interface AddProjektBilagParams {

    /**
     * Projektets ID.
     */
    projektId: string;

    /**
     * Projektets VersionsNr.
     */
    projektVersion?: number;
    fileInput?: Blob;
  }

  /**
   * Parameters for download
   */
  export interface DownloadParams {
    projektId: string;
    projektVersion?: number;
    bilagId?: string;
  }
}

export { ProjekterBilagService }
